import Mock from 'mockjs'

const {page, save} = require('../util');
const {dataItems} = require('./data');
const qs = require('qs');

Mock.mock('/dataItems/findAll', 'post', ({url, type, body}) => {
    let bodyObject = qs.parse(body);
    console.log('mock请求 url: %s, body: %o', url, bodyObject);
    bodyObject.data = page(dataItems, bodyObject);
    bodyObject.total = dataItems.length;
    return {
        code: 200,
        body: bodyObject,
    }
});

Mock.mock('/dataItems/save', 'post', ({url, type, body}) => {
    let bodyObject = qs.parse(body);
    console.log('mock请求 url: %s, body: %o', url, bodyObject);
    save(bodyObject, dataItems);
    return {
        code: 200,
        body: dataItems,
    }
});
